import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  columnsGasCompositionData,
  listDataGasCompositionData,
} from "./data/GasCompositionData";

import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import GasComposition from "./tab/GasComposition";
import PropTypes from "prop-types";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import classnames from "classnames";
import { connect } from "react-redux";
// import OverButton from "../../components/Custom/Overbutton";
import moment from "moment";
import { withTranslation } from "react-i18next";

//i18n
function Gas_Composition(props) {
  const [activeTab, setActiveTab] = useState("1");
  const [dateSelected, setDateSelected] = useState(moment().toDate());
  //sort Column//
  const defaultSorted = [
    {
      dataField: "Id",
      order: "asc",
    },
  ];

 
  //onInit//
  useEffect(function () {
    // addHeaderTable();
  }, []);
  //onInit//

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              {/* <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Gas Composition")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Manual Data Entry
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Gas Composition
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card> */}

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row>
                        <Col sm="12">
                          <FormGroup className="row">
                        
                            <Col
                              sm={9}
                              className=" d-flex align-items-center justify-content-end"
                            >
                              <h5> Data Date :</h5>
                            </Col>
                            <Col
                              sm={3}
                              className="d-flex align-items-center justify-content-start"
                            >
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                onChange={value => setDateSelected(...value)}
                                value={dateSelected}
                                options={{
                                  altInput: true,
                                  // altFormat: "d/m/Y",
                                  altFormat: "d F Y",
                                  dateFormat: "d/m/Y",
                                  maxDate: new Date(),
                                }}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row>
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                                 Gas Composition
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row>

                      <Row>
                        <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1">
                            {/* <Col sm="12">
                              <div>
                                <BootstrapTable
                                  keyField="Id"
                                  data={listDataGasCompositionData}
                                  columns={columnsGasCompositionData}
                                  headerClasses="header-style"
                                  // rowStyle={RowStyleFontWhite}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                  })}
                                  hover
                                />
                              </div>
                            </Col> */}
                            <GasComposition dateSelected={moment(dateSelected).add(-1,'day')}/>
                          </TabPane>
                        </TabContent>
                      </Row>

                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>

      {/*end : PageAdd */}
    </React.Fragment>
  );
}

Gas_Composition.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Gas_Composition }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Gas_Composition));
